import { createFileRoute } from '@tanstack/react-router';

import { getRouteHead } from '~/app/routeHead';
import Game from '~/game/Game';

export const Route = createFileRoute('/tournament')({
  component: Game,
  head: () => getRouteHead({ title: 'Tournament' }),
});
